import { makeEndpointFns } from '../fns';
import { DefectTicketSettings } from '@whiz-cart/node-shared/models/defect/ticket';
import {
    AssetDefect,
    AssetDefectRequestQuery,
    CancelAssetDefectTicketRequest,
    CreateAssetDefectTicketRequest,
    PagedAssetDefectResponse,
} from '@whiz-cart/node-shared/models/erp/asset';

const { GET, POST } = makeEndpointFns('storeManager');

export const assets = {
    /** Endpoints relating to asset defect tickets */
    tickets: {
        /** List defects for a specific asset */
        listAssetDefects: GET('api/v1/assetDefectTicket/getList', PagedAssetDefectResponse, {
            query: AssetDefectRequestQuery,
        }),

        /** Create a new asset defect ticket */
        createAssetDefect: POST('api/v1/assetDefectTicket/create', AssetDefect, {
            body: CreateAssetDefectTicketRequest,
        }),

        /** Cancel an existing asset defect ticket */
        cancelAssetDefect: POST('api/v1/assetDefectTicket/cancel', AssetDefect, {
            body: CancelAssetDefectTicketRequest,
        }),

        /** Get asset ticket settings for a store */
        getTicketSettings: GET('api/v1/assetDefectTicket/ticketSettings/{storeGuid}', DefectTicketSettings),
    },
};
